import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white stats-item" };
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 pt-lg-30 letter-spacing" };
const _hoisted_3 = { class: "row justify-content-between" };
const _hoisted_4 = { class: "col-md-6 mb-4" };
const _hoisted_5 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_6 = { class: "col-md-6 mb-4" };
const _hoisted_7 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_8 = { class: "row justify-content-between" };
const _hoisted_9 = { class: "col-md-6 mb-4" };
const _hoisted_10 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_11 = { class: "col-md-6 mb-4" };
const _hoisted_12 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_13 = { class: "info d-flex align-items-center justify-content-between mt-15" };
const _hoisted_14 = { class: "fs-13 d-block text-uppercase text-dark-emphasis fw-bold" };
const _hoisted_15 = { class: "d-flex align-items-center" };
const _hoisted_16 = { class: "fw-black mb-0 me-10 lh-1" };
const _hoisted_17 = { class: "fw-bold text-success text-badge d-inline-block" };
const _hoisted_18 = { class: "col-md-6" };
const _hoisted_19 = { class: "form-group position-relative transition mt-2" };
const _hoisted_20 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_21 = { class: "col-md-6" };
const _hoisted_22 = { class: "form-group position-relative transition mt-2" };
const _hoisted_23 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_24 = {
    key: 0,
    class: "info d-flex align-items-center justify-content-between mt-15"
};
const _hoisted_25 = { class: "fs-13 d-block text-uppercase text-dark-emphasis fw-bold" };
const _hoisted_26 = { class: "d-flex align-items-center" };
const _hoisted_27 = { class: "fw-black mb-0 me-10 lh-1" };
const _hoisted_28 = {
    key: 0,
    class: "fw-bold text-success text-badge d-inline-block"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_select = _resolveComponent("v-select");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", null, [
                        _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('forms.start')), 1),
                        _withDirectives(_createElementVNode("input", {
                            type: "date",
                            class: "form-control shadow-none rounded-0 text-black",
                            placeholder: "e.g. 2025-05-01",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.localStartDate) = $event)),
                            onChange: _cache[1] || (_cache[1] = (event) => _ctx.handleInput(event, 'startDate'))
                        }, null, 544), [
                            [_vModelText, _ctx.localStartDate]
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", null, [
                        _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('forms.end')), 1),
                        _withDirectives(_createElementVNode("input", {
                            type: "date",
                            class: "form-control shadow-none rounded-0 text-black",
                            placeholder: "e.g. 2025-05-01",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.localEndDate) = $event)),
                            onChange: _cache[3] || (_cache[3] = (event) => _ctx.handleInput(event, 'endDate'))
                        }, null, 544), [
                            [_vModelText, _ctx.localEndDate]
                        ])
                    ])
                ])
            ]),
            _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", null, [
                        _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('forms.startTime')), 1),
                        _withDirectives(_createElementVNode("input", {
                            type: "time",
                            class: "form-control shadow-none rounded-0 text-black",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.startTime) = $event)),
                            onChange: _cache[5] || (_cache[5] =
                                //@ts-ignore
                                (...args) => (_ctx.handleTimeChange && _ctx.handleTimeChange(...args)))
                        }, null, 544), [
                            [_vModelText, _ctx.startTime]
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", null, [
                        _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('forms.endTime')), 1),
                        _withDirectives(_createElementVNode("input", {
                            type: "time",
                            class: "form-control shadow-none rounded-0 text-black",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.endTime) = $event)),
                            onChange: _cache[7] || (_cache[7] =
                                //@ts-ignore
                                (...args) => (_ctx.handleTimeChange && _ctx.handleTimeChange(...args)))
                        }, null, 544), [
                            [_vModelText, _ctx.endTime]
                        ])
                    ])
                ])
            ]),
            _createElementVNode("div", _hoisted_13, [
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('forms.amountOrdersByCategory')), 1),
                _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("h4", _hoisted_16, _toDisplayString(_ctx.displayMontant) + " CHF ", 1),
                    _createElementVNode("span", _hoisted_17, [
                        _cache[10] || (_cache[10] = _createElementVNode("i", { class: "flaticon-up-arrow fs-11 lh-1 position-relative top-1" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.displayCommande) + " " + _toDisplayString(_ctx.$t('forms.orders')), 1)
                    ])
                ])
            ]),
            _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('forms.category')), 1),
                    _createVNode(_component_v_select, {
                        modelValue: _ctx.categorieSelected,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.categorieSelected) = $event)),
                        options: _ctx.originalCategories || [],
                        label: "name",
                        reduce: (categorie) => categorie.id,
                        getOptionKey: (categorie) => categorie.id,
                        placeholder: _ctx.$t('forms.category')
                    }, null, 8, ["modelValue", "options", "reduce", "getOptionKey", "placeholder"])
                ])
            ]),
            _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t('forms.product')), 1),
                    _createVNode(_component_v_select, {
                        modelValue: _ctx.productSelected,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.productSelected) = $event)),
                        options: _ctx.originalProducts || [],
                        label: "name",
                        reduce: (product) => product.id,
                        getOptionKey: (product) => product.id,
                        placeholder: _ctx.$t('forms.product')
                    }, null, 8, ["modelValue", "options", "reduce", "getOptionKey", "placeholder"])
                ])
            ]),
            (_ctx.productSelected && _ctx.productStats)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('forms.amountOrdersByProduct')), 1),
                    _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("h4", _hoisted_27, _toDisplayString(_ctx.productStats?.montant ?? 0) + " CHF ", 1),
                        (_ctx.productStats)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                                _cache[11] || (_cache[11] = _createElementVNode("i", { class: "flaticon-up-arrow fs-11 lh-1 position-relative top-1" }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.productStats?.commande ?? 0) + " " + _toDisplayString(_ctx.$t('forms.Orders')), 1)
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ]))
                : _createCommentVNode("", true)
        ])
    ]));
}
